<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Order",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { PageHeader, ModelListSelect, Loader },
  data() {
    return {
      title: "Add to Cart",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Order",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 1000,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      fields2: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QTY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "batch.batch_number",
          sortable: true,
          label: "BATCH",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      selected1: null,
      totalRows1: 1,

      currentPage1: 1,
      perPage1: 1000,
      filter1: null,
      todoFilter1: null,
      filterOn1: [],
      todofilterOn1: [],
      sortDesc1: false,
      modal_id1: "",
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "identification",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "inCart",
          sortable: true,
          label: "ITEMS",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],
      batchArr: [],
      unitName: "",
      customerdata: {
        contact: "",
        name: "",
        category_id: "",
        tindata: {
          tin: "",
        },
        efris_status: 0,
      },
      staffdata: {
        contact: "",
        name: "",
      },

      // Value from user input for adding position
      data: {
        quantity_taken: 1,
        product: "",
        unit: "",
        quantity: "",
        type: "",
        saletype: 1,
        description: "",
        batch: "",
        discount: 0,
        taxcategory: "",
      },

      labels: {
        instock: "",
        price: "",
      },
      add: {
        id: "",
        quantity_taken: "",
        product: "",
        unit: "",
        quantity: "",
        instock: "",
        type: "",
        saletype: 1,
      },
      hold: {
        identification: "",
      },
      totals: {
        paid: "",
        total: "",
        customer: "",
        mode: "",
        discount: 0,
        sale_date: null,
        change: "",
        picking_date: "",
        staff: "",
        vehicle_number: "",
        quotation_number: "",
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        type: "",
        product: "",
        base_qty: "",
        instock: "",
        quantity: "",
        quantity_taken: "",
        unit_price: "",
        discount: 0,
        taxcategory: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      unhold: {
        id: "",
      },
      deleteholddata: {
        id: "",
      },
      nameError: "",
      contactError: "",
      modeError: "",
      customerError: "",
      staffError: "",
      paidError: "",
      itemError: "",
      quantityError: "",
      qtyError: "",
      unitError: "",
      unit_priceError: "",
      quantity1Error: "",
      identificationError: "",
      FBatches: [],
      TotalCart: 0,
      manualOverride: false, // Flag to control the manual overwrite
      discountPercentValue: 0,
      discountBaseAmount: 0,
      discountModalContext: {
        target: "add-item",
        itemName: "",
      },
      printdeliverynote: false,
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapState("sales", ["total_cart", "saleId"]),
    ...mapGetters("sales", ["Products"]),
    ...mapGetters("sales", ["SaleSaveStatus", "Cart", "SaleHeld"]),
    ...mapGetters("setting", [
      "PaymentOptions",
      "GeneralSettings",
      "ReceiptSettings",
    ]),
    ...mapGetters("customers", [
      "Customers",
      "SaveStatus",
      "tinError",
      "CustomerDetails",
    ]),
    ...mapGetters("staff", ["Staff", "StaffSave", "DeliveryStaff"]),
    ...mapGetters("auth", [
      "name",
      "username",
      "MyUserPerm",
      "business",
      "branch",
    ]),
    ...mapGetters("products", ["Batches"]),
    ...mapGetters("retailoutlets", ["RetailOutlets"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QTY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ];

      if (this.GeneralSettings && this.GeneralSettings.sale_discount == 1) {
        baseFields.splice(5, 0, {
          key: "discount",
          sortable: true,
          label: "DISCOUNT",
        });
      }
      if (
        this.GeneralSettings &&
        this.GeneralSettings.attach_taxcategory_onselling == 1
      ) {
        baseFields.splice(6, 0, {
          key: "taxcategory",
          sortable: true,
          label: "TAX CATEGORY",
        });
      }
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.Cart ? this.Cart.length : 1;
    },

    /**
     * Todo list of records
     */
    calculatedDiscountValue() {
      if (!this.discountPercentValue || !this.discountBaseAmount) {
        return 0;
      }
      // Calculate discount amount (per unit for items, total for cart)
      const value = (this.discountPercentValue / 100) * this.discountBaseAmount;
      return value.toFixed(2); // Round to 2 decimal places
    },
  },

  mounted() {
    this.totalRows = this.Cart ? this.Cart.length : 1;
    this.focusProduct();
  },

  watch: {
    show(newValue) {
      if (newValue) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    PaymentOptions(newValue) {
      if (newValue) {
        this.setDefaultMode();
      }
    },
    saleId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_sale == 1) {
        if (this.printdeliverynote == true) {
          this.$router.push(`/printdeliverynote/${btoa(newValue)}`);
          this.printdeliverynote = false;
        } else if (this.ReceiptSettings.receipt_type == 1) {
          window.open(
            `https://${
              window.location.host
            }/receipts/salesreceipt.php?id=${btoa(newValue)}`,
          );
        } else if (this.ReceiptSettings.receipt_type == 2) {
          window.open(
            `https://${
              window.location.host
            }/receipts/salesreceiptv2.php?id=${btoa(newValue)}`,
          );
        } else if (this.ReceiptSettings.receipt_type == 3) {
          window.open(
            `https://${
              window.location.host
            }/receipts/salesreceiptv3.php?id=${btoa(newValue)}`,
          );
        } else if (this.ReceiptSettings.receipt_type == 4) {
          window.open(
            `https://${
              window.location.host
            }/receipts/salesreceiptv4.php?id=${btoa(newValue)}`,
          );
        } else if (this.ReceiptSettings.receipt_type == 5) {
          window.open(
            `https://${
              window.location.host
            }/receipts/deliverynote.php?id=${btoa(newValue)}`,
          );
        } else {
          window.open(
            `https://${
              window.location.host
            }/receipts/salesreceipt.php?id=${btoa(newValue)}`,
          );
        }
      }
    },

    GeneralSettings(newValue) {
      if (newValue.show_batch_selling == 1) {
        this.FetchBatches();
      }
    },

    // Fetch sale data
    Cart(newValue) {
      if (newValue && newValue.length > 0) {
        this.manualOverride = false; // Allow recalculations when Cart changes
        this.totals.customer = newValue[0].customer_id ?? "";
        this.totals.sale_date = newValue[0].date ?? "";
        this.totals.quotation_number = newValue[0].quotation_number ?? "";
        // this.totals.paid = newValue[0].paid?newValue[0].paid.toLocaleString():"";
      } else if (!newValue || newValue.length === 0) {
        this.resetTotals();
      }
    },

    CustomerDetails(newVale) {
      if (newVale) {
        if (this.CustomerDetails) {
          (this.customerdata.efris_status = 1),
            (this.customerdata.name = this.CustomerDetails.legalName);
          this.customerdata.contact = this.CustomerDetails.contactNumber;
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchCart: "sales/fetchCart",
      FetchHold: "sales/fetchHeld",
      FetchProducts: "sales/fetchItems",
      FetchCustomers: "customers/fetchCustomers",
      FetchStaff: "staff/fetchStaff",
      AddCart: "sales/addToCart",
      AddCart1: "sales/addToCart1",
      DeleteCartItem: "sales/deleteCart",
      FetchTotal: "sales/fetchTotCart",
      EditCartItems: "sales/editCart",
      SaveSalePrint: "sales/saveSalePrint",
      SaveSaleExit: "sales/saveSaleExit",
      Hold: "sales/holdSale",
      UnHold: "sales/unHoldSale",
      AddOrder: "sales/addHold",
      DeleteHold: "sales/deleteHold",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      AddCustomer: "customers/addCustomer",
      AddStaff: "staff/addStaff",
      LogOut: "auth/logout",
      FetchBatches: "products/fetchBatches",
      FetchRetailOutlets: "retailoutlets/fetchRetailOutlets",
      TinSubmit: "customers/fetchCustomerDetails",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // set comma separators
    paidCommas() {
      this.manualOverride = true;
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },

    discountCommas() {
      this.data.discount = this.data.discount.toLocaleString();
      this.editdata.discount = this.editdata.discount.toLocaleString();
    },

    buyingCommas() {
      this.data.unit_price = this.thousandSeprator(this.data.unit_price);
    },

    editBuyingCommas() {
      this.editdata.unit_price = this.thousandSeprator(
        this.editdata.unit_price,
      );
    },

    updateQtyTkn() {
      this.data.quantity_taken = this.data.quantity;
    },

    // Fetch product units
    assignArr() {
      let productID = this.data.product.split(" ")[0];
      let selectedPdt = this.Products.filter((product) => {
        return product.id == productID || product.code == this.data.product;
      });
      this.unitsArr = selectedPdt[0].units;
      this.unitName = selectedPdt[0].unitname;
      this.data.type = selectedPdt[0].type;
      this.data.unit = this.unitsArr[0].id;
      this.labels.instock = selectedPdt[0].instock;
      this.labels.price =
        this.data.saletype == 1
          ? selectedPdt[0].selling
          : selectedPdt[0].wholesale_unitprice;
    },

    assignArr2() {
      let selectedPdt = this.Products.filter((product) => {
        return (
          product.id == this.add.product || product.code == this.add.product
        );
      });
      this.unitsArr = selectedPdt[0].units;
      this.add.type = selectedPdt[0].type;
      this.add.unit = this.unitsArr[0].id;
      this.add.instock = selectedPdt[0].instock;
    },

    // Fetch batches
    FetchBatch() {
      this.FBatches = this.Batches.filter((batch) => {
        return batch.product_id == this.data.product.split(" ")[0];
      });
    },

    // Validate quantity being submitted
    validateQty() {
      if (
        this.data.product &&
        this.data.quantity &&
        this.data.unit &&
        this.data.type == 1
      ) {
        let tot = this.unitsArr.filter((unit) => {
          return unit.id == this.data.unit;
        });
        let totEqv = tot[0].base_qty * this.data.quantity;
        if (
          this.GeneralSettings.allow_negative_stock == 0 &&
          totEqv > this.labels.instock
        ) {
          this.quantityError = "Quantity Out Of Range";
          return;
        } else {
          this.quantityError = "";
        }
        if (this.data.quantity_taken > this.data.quantity) {
          this.quantityError = "Quantity Taken Out Of Range";
          return;
        } else {
          this.quantityError = "";
        }
      }
    },

    validateQty2() {
      if (
        this.add.product &&
        this.add.quantity &&
        this.add.unit &&
        this.add.type == 1
      ) {
        let tot = this.unitsArr.filter((unit) => {
          return unit.id == this.add.unit;
        });
        let totEqv = tot[0].base_qty * this.add.quantity;
        if (
          this.GeneralSettings.allow_negative_stock == 0 &&
          totEqv > this.add.instock
        ) {
          this.qtyError = "Quantity Out Of Range";
          return;
        } else {
          this.qtyError = "";
        }
      }
    },

    validateQty1() {
      if (
        this.editdata.product &&
        this.editdata.quantity &&
        this.editdata.type == 1
      ) {
        let tot = this.editdata.quantity * this.editdata.base_qty;
        if (
          this.GeneralSettings.allow_negative_stock == 0 &&
          tot > this.editdata.instock
        ) {
          this.quantity1Error = "Quantity Out Of Range";
          return;
        } else {
          this.quantity1Error = "";
        }
      }
    },

    // Check to restric duplicate product records into cart.
    checkItem() {
      if (this.data.product != "" && this.data.unit != "") {
        let productID = this.data.product.split(" ")[0];
        let batchID = this.data.batch ? this.data.batch.split(" ")[0] : "";
        this.existingItem = this.Cart.filter((item) => {
          if (batchID) {
            return item.product_id == productID &&
              item.unit_id == this.data.unit &&
              item.batch
              ? item.batch.id == batchID
              : "" ||
                (item.code == this.data.product &&
                  item.unit_id == this.data.unit &&
                  item.batch)
              ? item.batch.id == batchID
              : "";
          } else {
            return (
              (item.product_id == productID &&
                item.unit_id == this.data.unit) ||
              (item.code == this.data.product && item.unit_id == this.data.unit)
            );
          }
        });
        if (this.existingItem.length) {
          this.itemError = "This Item already exists";
          return;
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions
        ? this.PaymentOptions
        : [].filter((mode) => {
            return mode.default == 1;
          });
      this.totals.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    // Reset data fields
    resetData() {
      this.data.quantity_taken = 1;
      this.data.product = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.data.type = "";
      this.data.description = "";
      this.data.batch = "";
      this.data.discount = 0;
      this.data.taxcategory = "";
      this.labels.instock = "";
      this.labels.price = "";
    },
    resetDeleteItem() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEdit() {
      this.resetErrors();
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.product = "";
      this.editdata.type = 1;
      this.editdata.quantity = "";
      this.editdata.instock = "";
      this.editdata.base_qty = "";
      this.editdata.quantity_taken = "";
      this.editdata.unit_price = "";
      this.editdata.discount = 0;
      this.editdata.taxcategory = "";
      this.modal_id = "";
    },
    resetHold() {
      this.hold.identification = "";
    },

    resetErrors() {
      this.nameError = "";
      this.contactError = "";
      this.qtyError = "";
      this.itemError = "";
      this.unitError = "";
      this.quantityError = "";
      this.quantity1Error = "";
      this.unit_priceError = "";
      this.modeError = "";
      this.paidError = "";
      this.identificationError = "";
      this.customerError = "";
      this.staffError = "";
      this.tinError ? (this.tinError = "") : "";
    },

    resetTotals() {
      this.totals.total = 0;
      this.setDefaultMode();
      this.totals.paid = "";
      this.totals.discount = 0;
      this.totals.customer = "";
      this.totals.staff = "";
      this.totals.change = "";
      this.totals.picking_date = "";
      this.totals.vehicle_number = "";
    },
    resetCustomer() {
      this.customerdata.tindata.tin = "";
      this.customerdata.contact = "";
      this.customerdata.name = "";
    },
    resetStaff() {
      this.staffdata.contact = "";
      this.staffdata.name = "";
    },
    resetAdd() {
      this.add.id = "";
      this.add.product = "";
      this.add.quantity = "";
      this.add.unit = "";
    },

    // Fetch to assign value on button clicks
    showEditModal(data) {
      this.editdata.product = data.product_id;
      this.editdata.name = data.name;
      this.editdata.id = data.id;
      this.editdata.type = data.type;
      this.editdata.base_qty = data.baseQty;
      this.editdata.instock = data.instock;
      this.editdata.quantity = data.quantity;
      this.editdata.quantity_taken = data.quantity_taken;
      this.editdata.discount = this.thousandSeprator(data.discount);
      this.editdata.unit_price = this.thousandSeprator(data.selling);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.name;
      this.deletedata.id = data.id;
    },
    showAddModal(data) {
      this.add.id = data.id;
    },
    showUnHoldModal(data) {
      this.unhold.id = data.id;
    },
    showDeleteHoldModal(data) {
      this.deleteholddata.id = data.id;
    },

    // Edit cart
    editItem(modalId) {
      this.editdata.quantity_taken = this.editdata.quantity;
      this.modal_id = modalId;
      if (this.editdata.quantity == "" || this.editdata.quantity == 0) {
        this.quantity1Error = "Quantity Sold is required";
        return;
      }
      if (this.editdata.unit_price == "" || this.editdata.unit_price == 0) {
        this.unit_priceError = "Selling Price is required";
        return;
      }
      this.validateQty1();
      if (this.quantity1Error) {
        return;
      }
      this.EditCartItems(this.editdata);
      this.closeModal(modalId);
    },

    // Delete from cart
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
      this.closeModal(modalId);
      this.resetTotals();
    },

    // Save and Print
    saveSalePrint() {
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      let paid1 = this.totals.paid ? this.totals.paid.replaceAll(/,/g, "") : 0;
      let discount1 =
        this.totals.discount != 0
          ? this.totals.discount.replaceAll(/,/g, "")
          : 0;
      let tt = parseFloat(paid1) + parseFloat(discount1);
      if (this.totals.customer == "" && tt < this.totals.total) {
        this.customerError = "Customer is required";
        return;
      } else {
        this.customerError = "";
      }
      if (this.totals.paid == "") {
        this.totals.paid = 0;
      }
      this.SaveSalePrint(this.totals);
      this.resetTotals();
    },

    // Save and Exit
    saveSaleExit() {
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      let paid1 = this.totals.paid ? this.totals.paid.replaceAll(/,/g, "") : 0;
      let discount1 = this.totals.discount
        ? this.totals.discount.replaceAll(/,/g, "")
        : 0;
      let tt = parseFloat(paid1) + parseFloat(discount1);
      if (this.totals.customer == "" && tt < this.totals.total) {
        this.customerError = "Customer is required";
        return;
      } else {
        this.customerError = "";
      }
      if (this.totals.paid == "") {
        this.totals.paid = 0;
      }

      this.SaveSaleExit(this.totals);
      this.resetTotals();
      this.focusProduct();
    },

    // Show change or Customer balance
    showBalance() {
      let total1 = this.totals.total;
      let paid1 = this.totals.paid.replaceAll(/,/g, "");
      let discount1 =
        this.totals.discount != 0
          ? this.totals.discount.replaceAll(/,/g, "")
          : 0;
      let ttp = parseFloat(paid1) + parseFloat(discount1);
      if (this.totals.paid && total1 >= ttp) {
        this.totals.change = "Balance : " + this.thousandSeprator(total1 - ttp);
      } else if (this.totals.paid && total1 < ttp) {
        this.totals.change = "Change : " + this.thousandSeprator(ttp - total1);
      }
      if (paid1 == "") {
        this.totals.change = "Balance : " + this.thousandSeprator(total1);
      }
    },

    // Hold sale
    holdSale(mod) {
      this.modal_id = mod;
      if (this.hold.identification == "") {
        this.identificationError = "Identification is required";
        return;
      }
      this.Hold(this.hold);
      this.focusProduct();
    },

    // Add to cart for active and held sales
    addToCart() {
      this.data.quantity_taken = this.data.quantity;
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "" || this.data.quantity <= 0) {
        this.quantityError = "Quantity is required";
        return;
      } else {
        this.quantityError = "";
      }
      this.validateQty();
      if (this.quantityError.length) {
        return this.quantityError;
      } else {
        this.quantityError = "";
      }
      this.checkItem();
      this.data.product = this.data.product.split(" ")[0];
      this.data.batch = this.data.batch.split(" ")[0];
      this.AddCart(this.data);
      this.resetData();
      this.focusProduct();
    },

    addToCart1(model) {
      this.add.quantity_taken = this.add.quantity;
      this.modal_id = model;
      if (this.add.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.add.quantity == "" || this.add.quantity <= 0) {
        this.qtyError = "Quantity is required";
        return;
      } else {
        this.qtyError = "";
      }
      this.add.saletype = this.data.saletype;
      this.validateQty2();
      this.AddCart1(this.add);
      this.focusProduct();
    },

    UnHoldOrder(mod) {
      this.modal_id = mod;
      this.UnHold(this.unhold);
      this.focusProduct();
    },

    deleteHeldItem(mod) {
      this.modal_id = mod;
      this.DeleteHold(this.deleteholddata);
      this.focusProduct();
    },

    redirect(value) {
      this.$router.push(`/hold/print/${btoa(value)}`);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetAdd();
        this.resetCustomer();
        this.resetErrors();
        this.resetEdit();
        this.resetDeleteItem();
      });
    },

    // Validate Customer records
    validateCustomer() {
      if (this.customerdata.name != "" && this.customerdata.contact != "") {
        let selCust = this.Customers.filter((item) => {
          return item.phone == parseInt(this.customerdata.contact);
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError =
            "Customer with contact " +
            this.customerdata.contact +
            "  already Exists";
        }
      } else if (
        this.customerdata.name != "" &&
        this.customerdata.contact == ""
      ) {
        let selCust = this.Customers.filter((item) => {
          return (
            item.name.toLowerCase() == this.customerdata.name.toLowerCase()
          );
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError = "Customer with these details already Exists";
        }
      }
    },

    // Validate Staff records
    validateStaff() {
      if (this.staffdata.name != "" && this.staffdata.contact != "") {
        let selStaff = this.Customers.filter((item) => {
          return item.phone == parseInt(this.staffdata.contact);
        });
        let staffCount = selStaff.length;
        if (staffCount > 0) {
          this.contactError =
            "Customer with contact " +
            this.staffdata.contact +
            "  already Exists";
        }
      } else if (this.staffdata.name != "" && this.staffdata.contact == "") {
        let selStaff = this.Staff.filter((item) => {
          return item.name.toLowerCase() == this.staffdata.name.toLowerCase();
        });
        let staffCount = selStaff.length;
        if (staffCount > 0) {
          this.contactError = "Staff with these details already Exists";
        }
      }
    },

    // Add Customer
    addCustomer(modalId) {
      this.modal_id = modalId;
      if (this.customerdata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }

      this.validateCustomer();
      if (this.contactError != "") {
        return;
      }

      this.AddCustomer(this.customerdata);
      this.totals.customer = this.Customers[0].name - this.Customers[0].contact;
      this.closeModal(modalId);
    },

    // Add staff
    addStaff(modalId) {
      this.modal_id = modalId;

      if (this.staffdata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }

      this.validateStaff();
      if (this.contactError != "") {
        return;
      }

      this.AddStaff(this.staffdata);
      this.totals.staff = this.Staff[0].name - this.Staff[0].contact;
      this.closeModal(modalId);
    },

    nextPlease() {
      document.getElementById("input2").focus();
    },

    nextBatch() {
      document.getElementById("input3").focus();
    },

    logoutUser() {
      this.LogOut();
    },

    focusProduct() {
      document.getElementById("input1").focus();
    },
    focusCartPaid() {
      this.$refs.cartPaid.focus();
    },

    // Check customer balance
    CheckBalance() {
      if (this.GeneralSettings.show_customer_balances == 1) {
        let Balance = this.Customers.filter((bal) => {
          return bal.id == this.totals.customer;
        });
        if (Balance[0]) {
          this.totals.change =
            "Balance : " + Balance[0].balance.toLocaleString();
        } else {
          this.totals.change = "Balance : 0";
        }
      } else {
        return "";
      }
    },

    // Ceil sale total and paid amounts
    RoundupPaid() {
      this.manualOverride = true;
      this.totals.paid = (
        Math.ceil(this.totals.paid.replaceAll(/,/g, "") / 100) * 100
      ).toLocaleString();
      this.totals.total = Math.ceil(this.TotalCart / 100) * 100;
    },

    submitTin() {
      if (this.customerdata.tindata.tin == "") {
        this.tinError = "Tin field is required";
        return;
      } else {
        this.tinError = "";
        (this.customerdata.efris_status = 0),
          this.TinSubmit(this.customerdata.tindata);
      }
    },
    // Open modal from different contexts
    openDiscountModal(context, itemName = "") {
      this.discountModalContext.target = context;
      this.discountModalContext.itemName = itemName;

      // Set base amount based on context
      switch (context) {
        case "add-item":
          // Use amount (unit price * qty) as base
          this.discountBaseAmount =
            (parseFloat(this.labels.price) || 0) *
            (parseFloat(this.data.quantity) || 1);
          break;
        case "edit-item":
          this.discountBaseAmount =
            (parseFloat(
              this.editdata.unit_price.toString().replace(/,/g, ""),
            ) || 0) * (parseFloat(this.editdata.quantity) || 1);
          break;
        case "total":
          this.discountBaseAmount = this.TotalCart || 0;
          break;
      }

      this.discountPercentValue = 0;
      this.$bvModal.show("discount-percent-modal");
    },

    calculateDiscount() {
      // Auto-calculate whenever inputs change (handled by computed, but validate here)
      if (this.discountPercentValue < 0) this.discountPercentValue = 0;
      if (this.discountPercentValue > 100) this.discountPercentValue = 100;
    },

    applyPercentDiscount() {
      // Only fill the discount field with the percentage digit and % sign
      const percent = this.discountPercentValue;
      if (percent !== null && percent !== undefined && percent !== "") {
        switch (this.discountModalContext.target) {
          case "add-item":
            this.data.discount = percent + "%";
            break;
          case "edit-item":
            this.editdata.discount = percent + "%";
            break;
          case "total":
            this.totals.discount = percent + "%";
            break;
        }
      }
      this.$bvModal.hide("discount-percent-modal");
    },

    resetDiscountModal() {
      this.discountPercentValue = 0;
      this.discountBaseAmount = 0;
      this.discountModalContext = {
        target: "add-item",
        baseAmount: 0,
        itemName: "",
      };
    },

    processSale(isPrinting) {
      this.productnames = "";
      this.productcount = 0;
      this.price_below_costprice = "";
      this.price_below_costprice_count = 0;

      this.Cart.forEach((item) => {
        if (item.selling < item.reserve && item.item_type == 1) {
          this.productnames = this.productnames + ", " + item.name;
          this.productcount++;
        }
        if (item.selling < item.buying_price && item.item_type == 1) {
          this.price_below_costprice =
            this.price_below_costprice + ", " + item.name;
          this.price_below_costprice_count++;
        }
      });

      if (
        this.productcount > 0 &&
        this.GeneralSettings.allow_reserve_price == 1 &&
        !this.GeneralSettings.use_customer_prices
      ) {
        Swal.fire(
          "Error!",
          `${this.productcount} Product(s) [${this.productnames.substring(
            2,
          )}] have selling price lower than reserve price.`,
          "error",
        );
        return;
      } else if (
        this.price_below_costprice_count > 0 &&
        !this.GeneralSettings.sell_below_costprice
      ) {
        Swal.fire(
          "Error!",
          `${
            this.price_below_costprice_count
          } Product(s) [${this.price_below_costprice.substring(
            2,
          )}] have selling price lower than buying price.`,
          "error",
        );
        return;
      }

      const saleData = JSON.parse(JSON.stringify(this.totals));
      let totalPaidAmount = 0;

      if (this.splitPaymentActive) {
        saleData.payments = saleData.payments.filter(
          (p) =>
            p.method &&
            p.amount &&
            parseFloat(String(p.amount).replace(/,/g, "")) > 0,
        );
        if (saleData.payments.length === 0) {
          this.modeError = "At least one valid split payment is required.";
          return;
        }
        totalPaidAmount = this.totalPaidFromSplits;
      } else {
        if (!saleData.mode) {
          this.modeError = "Payment Method is required.";
          return;
        }
        totalPaidAmount =
          parseFloat(String(saleData.paid).replace(/,/g, "")) || 0;
        saleData.payments = [
          { method: saleData.mode, amount: totalPaidAmount },
        ];
      }
      this.modeError = "";

      let discountAmount =
        parseFloat(String(saleData.discount).replace(/,/g, "")) || 0;
      if (
        !saleData.customer &&
        totalPaidAmount + discountAmount < saleData.total
      ) {
        this.customerError = "Customer is required for credit sales.";
        return;
      }
      this.customerError = "";

      if (!saleData.customer && this.GeneralSettings.customer_per_sale) {
        this.customerError = "Customer is required.";
        return;
      }
      this.customerError = "";

      if (this.GeneralSettings.enable_debt_limit == 1 && saleData.customer) {
        this.customerError = "";
        let SelectCustomer = this.Customers.filter((item) => {
          return item.id === saleData.customer;
        });
        this.limit = SelectCustomer[0].debt_limit;
        this.balance = SelectCustomer[0].balance;
        if (
          this.limit <
          saleData.total - (totalPaidAmount + discountAmount + this.balance)
        ) {
          this.customerError = "The debt limit is exceeded";
          return;
        } else {
          this.customerError = "";
        }
      }

      if (this.Cart[0]?.conversion_rate > 1) {
        saleData.rate = this.Cart[0].conversion_rate;
        saleData.currency = this.Cart[0].currency;
        saleData.total = saleData.total / saleData.rate;
        saleData.discount = discountAmount / saleData.rate;
        saleData.payments = saleData.payments.map((p) => ({
          ...p,
          amount: p.amount / saleData.rate,
        }));
      }

      if (isPrinting) {
        this.SaveSalePrint(saleData);
      } else {
        this.SaveSaleExit(saleData);
      }

      this.resetTotals();
      if (!isPrinting) this.focusProduct();
    },

    saveSalePrintDelivery() {
      this.printdeliverynote = true;
      this.processSale(true);
    },
  },

  created() {
    this.FetchGeneralSettings();
    this.setDefaultMode();
    this.fetchReceiptSettings();
    this.FetchCustomers();
    this.FetchStaff();
    this.FetchProducts();
    this.FetchCart();
    this.FetchHold();
    this.FetchTotal();
    this.FetchModes();
    this.FetchRetailOutlets();
  },

  updated() {
    if (this.manualOverride) {
      return;
    }
    if (this.Cart) {
      let sumedtotal = 0;
      let totaldiscount = 0;
      this.Cart.forEach((item) => {
        sumedtotal = sumedtotal + parseFloat(item.quantity * item.selling);
        totaldiscount = totaldiscount + item.discount;
      });
      this.totals.discount = totaldiscount.toLocaleString();
      this.TotalCart = sumedtotal;
    }
    if (this.GeneralSettings.set_total_as_paid == 1 && this.TotalCart) {
      this.totals.paid = this.thousandSeprator(
        this.TotalCart - this.totals.discount.replaceAll(/,/g, ""),
      );
    } else {
      this.totals.paid = 0;
    }
    this.totals.total = this.TotalCart;
  },
};
</script>

<template>
  <Layout>
    <div class="row bg-warning fixed-header">
      <div class="col-md-2" align="center">
        <router-link to="/dashboard" class="btn btn-info mt-3 ml-5">
          <i class="fa fa-arrow-left"></i> Back to Dashboard
        </router-link>
      </div>
      <div class="col-md-8" align="center">
        <div class="row py-3 text-center">
          <h4
            v-if="GeneralSettings.show_businessname == 1"
            class="text-primary"
          >
            {{ business }}
          </h4>
          <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
            <em
              v-if="
                GeneralSettings.show_branchname == 1 &&
                GeneralSettings.show_businessname == 1
              "
              >-</em
            >
            {{ branch }}
          </h4>
        </div>
      </div>
      <div class="col-md-2" align="right">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/user1.png"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1 text-white">
              {{ name ? name : "Poscream User" }}
            </span>
            <i
              class="mdi mdi-chevron-down d-none d-xl-inline-block text-white"
            ></i>
          </template>
          <!-- item-->

          <b-dropdown-divider></b-dropdown-divider>
          <a href="#" class="dropdown-item text-danger">
            <button class="btn btn-outline" @click="logoutUser()">
              <i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
              ></i>
              Logout
            </button>
          </a>
        </b-dropdown>
      </div>
    </div>

    <div class="fixed-header-spacer">
      <PageHeader :title="title" :items="items" class="px-5 mt-2" />

      <!-- Display is showing batch numbers on selling is enabled starts-->
      <div class="row px-5" v-if="GeneralSettings.show_batch_selling == 1">
        <div class="col-md-9 mb-5">
          <div class="card">
            <div class="card-body">
              <div class="row" v-if="GeneralSettings.enable_wholeselling == 1">
                <div class="col-sm-5">
                  <div class="form-group mb-3">
                    <select class="form-control" v-model="data.saletype">
                      <option value="1">Retail</option>
                      <option value="2">Wholesale</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Product
                      <span class="text-danger"
                        >*<em class="text-primary h5" v-if="data.product != ''">
                          Price:
                          {{
                            labels.price ? labels.price.toLocaleString() : 0
                          }}</em
                        ></span
                      ></label
                    >
                    <input
                      id="input1"
                      class="form-control"
                      style="font-size: 15px"
                      v-model="data.product"
                      list="products"
                      placeholder="Select Product or Enter Barcode"
                      @input="resetErrors()"
                      @keyup.enter="nextBatch()"
                      @change="assignArr(), FetchBatch()"
                      @keyup.esc="focusCartPaid()"
                    />
                    <datalist id="products">
                      <option
                        v-for="(pdt, p) in Products"
                        :value="pdt.name1"
                        :key="p"
                      ></option>
                    </datalist>
                    <div
                      class="text-primary h5"
                      v-if="labels.instock > 0 || labels.instock == '0'"
                    >
                      <em
                        >Quantity in stock: {{ labels.instock
                        }}{{ unitName }}</em
                      >
                    </div>
                    <div class="text-danger" v-if="itemError">
                      <em>{{ itemError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px">Batch </label>
                    <input
                      list="batches"
                      id="input3"
                      class="form-control"
                      style="font-size: 15px"
                      v-model="data.batch"
                      placeholder="Select Batch"
                      @keyup.enter="nextPlease()"
                    />
                    <datalist id="batches">
                      <option
                        v-for="(batch, b) in FBatches"
                        :value="
                          batch.id +
                          ' | ' +
                          batch.batch_number +
                          ' - - ' +
                          batch.expiry_date
                        "
                        :key="b"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Qty <span class="text-danger">*</span></label
                    >
                    <input
                      id="input2"
                      type="number"
                      class="form-control"
                      step="any"
                      v-model="data.quantity"
                      @input="resetErrors(), updateQtyTkn()"
                      @keyup.enter="addToCart()"
                      @keyup.esc="focusCartPaid()"
                      placeholder="Enter Qty"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-2"
                  v-if="GeneralSettings.allow_multiple_units == 1"
                >
                  <div class="form-group mb-3">
                    <label style="font-size: 18px">Units</label>
                    <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="data.unit"
                      option-value="id"
                      option-text="unitname"
                      placeholder="Unit"
                      style="font-size: 15px"
                      @input="resetErrors(), checkItem()"
                      @keyup.enter="addToCart()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5" v-if="GeneralSettings.sale_discount == 1">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Discount Received
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="openDiscountModal('add-item', data.product)"
                        style="
                          padding: 2px 8px;
                          font-size: 12px;
                          margin-left: 5px;
                        "
                      >
                        %
                      </b-button>
                    </label>
                    <input
                      type="text"
                      style="font-size: 15px"
                      class="form-control"
                      v-model="data.discount"
                      @keyup.enter="addToCart()"
                      @input="discountCommas(), showBalance()"
                      min="0"
                    />
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group mb-3">
                    <br />
                    <button
                      class="btn btn-info mt-2"
                      @click="addToCart()"
                      v-if="SaleSaveStatus"
                    >
                      <i class="fa fa-plus"></i> Add
                      <b-spinner
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                    </button>
                    <button
                      class="btn btn-info mt-2"
                      @click="addToCart()"
                      v-else
                    >
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" v-if="GeneralSettings.sale_description == 1">
                <div class="form-group mb-3">
                  <label>Description</label>
                  <textarea
                    @keyup.enter="addToCart()"
                    type="text"
                    class="form-control"
                    v-model="data.description"
                    cols="30"
                    rows="5"
                  ></textarea>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  style="font-size: 16px"
                  v-if="Cart && Cart.length > 0"
                  :items="Cart ? Cart : []"
                  :fields="fields2"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(total_price)="data">
                    {{
                      data.item.selling
                        ? thousandSeprator(
                            data.item.selling * data.item.quantity,
                          )
                        : 0
                    }}
                  </template>

                  <template #cell(unit_price)="data">
                    {{
                      data.item.selling
                        ? thousandSeprator(data.item.selling)
                        : 0
                    }}
                  </template>
                  <template #cell(quantity_field)="data">
                    {{ data.item ? data.item.quantity : 0 }}
                    {{ data.item ? data.item.unit : 0 }}
                  </template>

                  <template #cell(actions)="data">
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                      ><i class="fa fa-edit"></i
                    ></b-button>
                    <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                      ><i class="fa fa-trash"></i
                    ></b-button>
                  </template>
                </b-table>
              </div>
              <Loader v-if="!Cart" />
            </div>
          </div>
          <!-- Start hold -->
          <div
            class="card"
            v-if="GeneralSettings.sale_holding == 1 && SaleHeld != ''"
          >
            <div class="card-body">
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  :items="SaleHeld ? SaleHeld : []"
                  :fields="fields1"
                  responsive="sm"
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :filter-included-fields="filterOn1"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <b-button-group>
                      <b-button
                        v-b-modal.unhold-item-modal
                        variant="success"
                        size="sm"
                        @click="showUnHoldModal(data.item)"
                        ><i class="fa fa-undo"></i>UnHold</b-button
                      >
                      <b-button
                        v-b-modal.add-item-modal
                        variant="info"
                        size="sm"
                        @click="showAddModal(data.item)"
                        ><i class="fa fa-plus"></i>Add</b-button
                      >
                      <b-button
                        size="sm"
                        variant="primary"
                        @click="redirect(data.item.id)"
                        ><i class="fa fa-print"></i> Print</b-button
                      >
                      <b-button
                        v-b-modal.delete-hold-item-modal
                        variant="danger"
                        size="sm"
                        @click="showDeleteHoldModal(data.item)"
                        ><i class="fa fa-trash"></i> Delete</b-button
                      >
                    </b-button-group>
                  </template>
                </b-table>
              </div>
              <div align="right">
                <router-link to="/sales/held" class="btn btn-info btn-sm">
                  <i class="fa fa-eye"></i> View All
                </router-link>
              </div>
              <Loader v-if="!Cart" />
            </div>
          </div>
          <!-- End hold -->
        </div>

        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <form action="">
                <div class="row" v-if="TotalCart > 0">
                  <div class="col-12 text-center">
                    <h4 style="font-size: 30px">
                      <strong
                        >TOTAL:
                        {{
                          TotalCart ? thousandSeprator(TotalCart) : 0
                        }}/=</strong
                      >
                    </h4>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label style="font-size: 20px">Amount Paid</label>
                  <input
                    type="text"
                    ref="cartPaid"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.paid"
                    @input="paidCommas(), resetErrors(), showBalance()"
                    @keyup.esc="focusProduct()"
                    @keyup.page-down="saveSalePrint()"
                    @keyup.page-up="saveSaleExit()"
                    min="0"
                  />
                </div>
                <div class="text-primary h5" v-if="totals.change">
                  <em>{{ totals.change }}</em>
                </div>
                <div class="form-group mb-2">
                  <label style="font-size: 20px"
                    >Payment Method <span class="text-danger">*</span></label
                  >
                  <model-list-select
                    :list="PaymentOptions ? PaymentOptions : []"
                    v-model="totals.mode"
                    style="font-size: 15px"
                    option-value="id"
                    option-text="mode"
                    placeholder="Select Method"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.sale_discount == 1"
                >
                  <label style="font-size: 20px">Discount Received</label>
                  <input
                    readonly
                    type="text"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.discount"
                    @input="discountCommas(), resetErrors(), showBalance()"
                    min="0"
                  />
                </div>

                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.back_date_sales == 1"
                >
                  <label style="font-size: 20px"
                    >Sale Date <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.sale_date"
                    v-limit-future-date
                    @input="resetErrors()"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="GeneralSettings.track_customers == 1"
                >
                  <label style="font-size: 20px"
                    >Customer
                    <span v-if="MyUserPerm && MyUserPerm.add_customers == 1">
                      <b-button
                        size="sm"
                        style="font-size: 20px"
                        variant="link"
                        v-b-modal.add-customer-modal
                      >
                        New
                      </b-button>
                    </span>
                  </label>
                  <model-list-select
                    :list="Customers ? Customers : []"
                    v-model="totals.customer"
                    option-value="id"
                    option-text="name1"
                    placeholder="Select Customer"
                    @input="resetErrors(), CheckBalance()"
                    @keyup.enter="saveSale()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="customerError">
                  <em>{{ customerError }}</em>
                </div>

                <div
                  class="form-group"
                  v-if="GeneralSettings.capture_delivery_staff == 1"
                >
                  <label style="font-size: 20px">Staff</label>
                  <model-list-select
                    :list="DeliveryStaff ? DeliveryStaff : []"
                    v-model="totals.staff"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Staff"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="staffError">
                  <em>{{ staffError }}</em>
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.capture_delivery_staff == 1"
                >
                  <label style="font-size: 20px">Vehicle Number</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="totals.vehicle_number"
                    placeholder="Enter vehicle number"
                    @input="resetErrors()"
                  />
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.sale_pickingdate == 1"
                >
                  <label style="font-size: 20px">Picking Date</label>
                  <input
                    style="font-size: 20px"
                    @keyup.enter="addToCart()"
                    type="date"
                    class="form-control"
                    v-model="totals.picking_date"
                    v-limit-future-date
                    
                  />
                </div>
                <div class="form-group text-center">
                  <div class="row mt-3">
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm &&
                        MyUserPerm.new_sale == 1 &&
                        ReceiptSettings.print_receipt_after_sale == 1 &&
                        TotalCart > 0
                      "
                    >
                      <b-button v-if="SaleSaveStatus" variant="primary" disabled
                        ><i class="fa fa-check"></i> Save & Print
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button
                        v-else
                        @click="saveSalePrint()"
                        variant="primary"
                        ><i class="fa fa-check"></i> Save & Print
                      </b-button>
                    </div>
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm && MyUserPerm.new_sale == 1 && TotalCart > 0
                      "
                    >
                      <b-button v-if="SaleSaveStatus" variant="primary" disabled
                        ><i class="fa fa-check"></i> Save & Exit
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button v-else @click="saveSaleExit()" variant="primary"
                        ><i class="fa fa-check"></i> Save & Exit
                      </b-button>
                    </div>
                    <div
                      class="col-md-6"
                      v-if="GeneralSettings.sale_holding == 1"
                    >
                      <b-button v-if="SaleSaveStatus" variant="danger" disabled
                        ><i class="fa fa-ban"></i> Hold
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button v-else variant="danger" v-b-modal.hold-modal
                        ><i class="fa fa-ban"></i> Hold
                      </b-button>
                    </div>
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm &&
                        MyUserPerm.new_sale == 1 &&
                        ReceiptSettings.print_deliverynotes == 1 &&
                        ReceiptSettings.print_receipt_after_sale == 1 &&
                        (TotalCart > 0 ||
                          (Cart && Cart.length > 0 && Cart[0].item_type != 1))
                      "
                    >
                      <b-button
                        @click="saveSalePrintDelivery()"
                        :disabled="SaleSaveStatus"
                        variant="primary"
                        ><i class="fa fa-check"></i> Generate Delivery Note
                        <b-spinner v-if="SaleSaveStatus" small></b-spinner>
                      </b-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Display is showing batch numbers on selling is enabled ends-->
      <div class="row px-5" v-else>
        <div class="col-md-8 mb-5">
          <div class="card">
            <div class="card-body">
              <!-- Give options to sell or wholesale or retail -->
              <div class="row" v-if="GeneralSettings.enable_wholeselling == 1">
                <div class="col-sm-5">
                  <div class="form-group mb-3">
                    <select class="form-control" v-model="data.saletype">
                      <option value="1">Retail</option>
                      <option value="2">Wholesale</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Product
                      <span class="text-danger"
                        >*
                        <em class="text-primary h5" v-if="data.product != ''">
                          Price:
                          {{
                            labels.price ? labels.price.toLocaleString() : 0
                          }}</em
                        >
                      </span></label
                    >
                    <input
                      id="input1"
                      class="form-control"
                      style="font-size: 15px"
                      v-model="data.product"
                      list="products"
                      placeholder="Select Product or Enter Barcode"
                      @input="resetErrors(), assignArr()"
                      @keyup.enter="nextPlease()"
                      @keyup.esc="focusCartPaid()"
                    />
                    <datalist id="products">
                      <option
                        v-for="(pdt, p) in Products"
                        :value="pdt.name1"
                        :key="p"
                      ></option>
                    </datalist>
                    <div
                      class="text-primary h5"
                      v-if="labels.instock > 0 || labels.instock == '0'"
                    >
                      <em
                        >Quantity in stock: {{ labels.instock
                        }}{{ unitName }}</em
                      >
                    </div>
                    <div class="text-danger" v-if="itemError">
                      <em>{{ itemError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Qty <span class="text-danger">*</span></label
                    >
                    <input
                      id="input2"
                      type="number"
                      class="form-control"
                      step="any"
                      v-model="data.quantity"
                      @input="resetErrors(), updateQtyTkn()"
                      @keyup.enter="addToCart()"
                      @keyup.esc="focusCartPaid()"
                      placeholder="Enter Qty"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-3"
                  v-if="GeneralSettings.allow_multiple_units == 1"
                >
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Unit Measure <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="data.unit"
                      option-value="id"
                      option-text="unitname"
                      placeholder="Unit"
                      style="font-size: 15px"
                      @input="resetErrors(), checkItem()"
                      @keyup.enter="addToCart()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-2"
                  v-if="
                    GeneralSettings.sale_discount == 0 &&
                    GeneralSettings.attach_taxcategory_onselling == 0
                  "
                >
                  <div class="form-group mb-3">
                    <br />
                    <button
                      class="btn btn-info mt-3"
                      @click="addToCart()"
                      v-if="SaleSaveStatus"
                    >
                      <i class="fa fa-plus"></i> Add
                      <b-spinner
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                    </button>
                    <button
                      class="btn btn-info mt-3"
                      @click="addToCart()"
                      v-else
                    >
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </div>
                </div>

                <div class="col-sm-5" v-if="GeneralSettings.sale_discount == 1">
                  <div class="form-group mb-3">
                    <label style="font-size: 18px"
                      >Discount Received
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="openDiscountModal('add-item', data.product)"
                        style="
                          padding: 2px 8px;
                          font-size: 12px;
                          margin-left: 5px;
                        "
                      >
                        %
                      </b-button>
                    </label>
                    <input
                      type="text"
                      style="font-size: 15px"
                      class="form-control"
                      v-model="data.discount"
                      @keyup.enter="addToCart()"
                      @input="discountCommas(), showBalance()"
                      min="0"
                    />
                  </div>
                </div>

                <div
                  class="col-sm-3"
                  v-if="GeneralSettings.attach_taxcategory_onselling == 1"
                >
                  <div class="form-group mb-3">
                    <label style="font-size: 18px">Tax Category</label>
                    <select
                      v-model="data.taxcategory"
                      class="form-control"
                      style="font-size: 15px"
                    >
                      <option value="">Default</option>
                      <option value="01">Standard (18%)</option>
                      <option value="02">Zero Rated (0%)</option>
                      <option value="03">Exempt (-)</option>
                    </select>
                  </div>
                </div>

                <div
                  class="col-sm-2"
                  v-if="
                    GeneralSettings.sale_discount == 1 ||
                    GeneralSettings.attach_taxcategory_onselling == 1
                  "
                >
                  <div class="form-group mb-3">
                    <br />
                    <button
                      class="btn btn-info mt-3"
                      @click="addToCart()"
                      v-if="SaleSaveStatus"
                    >
                      <i class="fa fa-plus"></i> Add
                      <b-spinner
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                    </button>
                    <button
                      class="btn btn-info mt-3"
                      @click="addToCart()"
                      v-else
                    >
                      <i class="fa fa-plus"></i> Add
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" v-if="GeneralSettings.sale_description == 1">
                <div class="form-group mb-3">
                  <label>Description</label>
                  <textarea
                    @keyup.enter="addToCart()"
                    type="text"
                    class="form-control"
                    v-model="data.description"
                    cols="30"
                    rows="5"
                  ></textarea>
                </div>
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  style="font-size: 16px"
                  :items="Cart ? Cart : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(total_price)="data">
                    {{
                      data.item.selling
                        ? thousandSeprator(
                            data.item.selling * data.item.quantity,
                          )
                        : 0
                    }}
                  </template>

                  <template #cell(unit_price)="data">
                    {{
                      data.item.selling
                        ? thousandSeprator(data.item.selling)
                        : 0
                    }}
                  </template>
                  <template #cell(quantity_field)="data">
                    {{ data.item ? data.item.quantity : 0 }}
                    {{ data.item ? data.item.unit : 0 }}
                  </template>
                  <template #cell(discount)="data">
                    {{
                      data.item.discount
                        ? thousandSeprator(data.item.discount)
                        : 0
                    }}
                  </template>

                  <template #cell(actions)="data">
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                      ><i class="fa fa-edit"></i
                    ></b-button>
                    <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                      ><i class="fa fa-trash"></i
                    ></b-button>
                  </template>
                </b-table>
              </div>
              <Loader v-if="!Cart" />
            </div>
          </div>
          <!-- Start hold -->
          <div
            class="card"
            v-if="GeneralSettings.sale_holding == 1 && SaleHeld != ''"
          >
            <div class="card-body">
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  :items="SaleHeld ? SaleHeld : []"
                  :fields="fields1"
                  responsive="sm"
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :filter-included-fields="filterOn1"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <b-button-group>
                      <b-button
                        v-b-modal.unhold-item-modal
                        variant="success"
                        size="sm"
                        @click="showUnHoldModal(data.item)"
                        ><i class="fa fa-undo"></i>UnHold</b-button
                      >
                      <b-button
                        v-b-modal.add-item-modal
                        variant="info"
                        size="sm"
                        @click="showAddModal(data.item)"
                        ><i class="fa fa-plus"></i>Add</b-button
                      >
                      <b-button
                        size="sm"
                        v-if="MyUserPerm && MyUserPerm.print_heldsales == 1"
                        variant="primary"
                        @click="redirect(data.item.id)"
                        ><i class="fa fa-print"></i> Print</b-button
                      >
                      <b-button
                        v-b-modal.delete-hold-item-modal
                        variant="danger"
                        size="sm"
                        @click="showDeleteHoldModal(data.item)"
                        ><i class="fa fa-trash"></i> Delete</b-button
                      >
                    </b-button-group>
                  </template>
                </b-table>
              </div>
              <div align="right">
                <router-link to="/sales/held" class="btn btn-info btn-sm">
                  <i class="fa fa-eye"></i> View All
                </router-link>
              </div>
              <Loader v-if="!Cart" />
            </div>
          </div>
          <!-- End hold -->
        </div>

        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <form action="">
                <div class="row" v-if="TotalCart > 0">
                  <div class="col-12 text-center">
                    <h4 style="font-size: 30px">
                      <strong
                        >TOTAL:
                        {{
                          TotalCart ? thousandSeprator(TotalCart) : 0
                        }}/=</strong
                      >
                    </h4>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label style="font-size: 20px"
                    >Amount Paid
                    <span v-if="GeneralSettings.allow_sales_roundup == 1">
                      <b-button
                        size="sm"
                        style="font-size: 20px"
                        variant="link"
                        @click="RoundupPaid()"
                      >
                        Round up
                      </b-button>
                    </span>
                  </label>
                  <input
                    type="text"
                    ref="cartPaid"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.paid"
                    @input="paidCommas(), resetErrors(), showBalance()"
                    @keyup.esc="focusProduct()"
                    @keyup.page-down="saveSalePrint()"
                    @keyup.page-up="saveSaleExit()"
                    min="0"
                  />
                </div>
                <div class="text-primary h5" v-if="totals.change">
                  <em>{{ totals.change }}</em>
                </div>
                <div class="form-group mb-2">
                  <label style="font-size: 20px"
                    >Payment Method <span class="text-danger">*</span></label
                  >
                  <model-list-select
                    :list="PaymentOptions ? PaymentOptions : []"
                    v-model="totals.mode"
                    style="font-size: 15px"
                    option-value="id"
                    option-text="mode"
                    placeholder="Select Method"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.sale_discount == 1"
                >
                  <label style="font-size: 20px">Discount Received</label>
                  <input
                    type="text"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.discount"
                    @input="discountCommas(), resetErrors(), showBalance()"
                    min="0"
                  />
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.back_date_sales == 1"
                >
                  <label style="font-size: 20px"
                    >Sale Date <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    style="font-size: 20px"
                    class="form-control"
                    v-model="totals.sale_date"
                    v-limit-future-date
                    @input="resetErrors()"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="GeneralSettings.track_customers == 1"
                >
                  <label style="font-size: 20px"
                    >Customer <span class="text-danger">*</span>
                    <span v-if="MyUserPerm && MyUserPerm.add_customers == 1">
                      <b-button
                        size="sm"
                        style="font-size: 20px"
                        variant="link"
                        v-b-modal.add-customer-modal
                      >
                        New
                      </b-button>
                    </span>
                  </label>
                  <model-list-select
                    :list="Customers ? Customers : []"
                    v-model="totals.customer"
                    option-value="id"
                    option-text="name1"
                    placeholder="Select Customer"
                    @input="resetErrors(), CheckBalance()"
                    @keyup.enter="saveSale()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="customerError">
                  <em>{{ customerError }}</em>
                </div>
                <div
                  class="form-group"
                  v-if="GeneralSettings.capture_delivery_staff == 1"
                >
                  <label style="font-size: 20px">Staff</label>
                  <model-list-select
                    :list="DeliveryStaff ? DeliveryStaff : []"
                    v-model="totals.staff"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Staff"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="staffError">
                  <em>{{ staffError }}</em>
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.capture_delivery_staff == 1"
                >
                  <label style="font-size: 20px">Vehicle Number</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="totals.vehicle_number"
                    placeholder="Enter vehicle number"
                    @input="resetErrors()"
                  />
                </div>
                <div
                  class="form-group mb-2"
                  v-if="GeneralSettings.sale_pickingdate == 1"
                >
                  <label style="font-size: 20px">Picking Date</label>
                  <input
                    style="font-size: 20px"
                    type="date"
                    class="form-control"
                    v-model="totals.picking_date"
                    v-limit-future-date
                  />
                </div>
                <div class="form-group text-center">
                  <div class="row mt-3">
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm &&
                        MyUserPerm.new_sale == 1 &&
                        ReceiptSettings.print_receipt_after_sale == 1 &&
                        TotalCart > 0
                      "
                    >
                      <b-button v-if="SaleSaveStatus" variant="primary" disabled
                        ><i class="fa fa-check"></i> Save & Print
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button
                        v-else
                        @click="saveSalePrint()"
                        variant="primary"
                        ><i class="fa fa-check"></i> Save & Print
                      </b-button>
                    </div>
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm && MyUserPerm.new_sale == 1 && TotalCart > 0
                      "
                    >
                      <b-button v-if="SaleSaveStatus" disabled variant="primary"
                        ><i class="fa fa-check"></i> Save & Exit
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button v-else @click="saveSaleExit()" variant="primary"
                        ><i class="fa fa-check"></i> Save & Exit
                      </b-button>
                    </div>
                    <div
                      class="col-md-6"
                      v-if="GeneralSettings.sale_holding == 1"
                    >
                      <b-button v-if="SaleSaveStatus" disabled variant="danger"
                        ><i class="fa fa-ban"></i> Hold
                        <b-spinner
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                      <b-button v-else variant="danger" v-b-modal.hold-modal
                        ><i class="fa fa-ban"></i> Hold
                      </b-button>
                    </div>
                    <div
                      class="col-md-6 mb-3"
                      v-if="
                        MyUserPerm &&
                        MyUserPerm.new_sale == 1 &&
                        ReceiptSettings.print_receipt_after_sale == 1 &&
                        (TotalCart > 0 ||
                          (Cart && Cart.length > 0 && Cart[0].item_type != 1))
                      "
                    >
                      <b-button
                        @click="saveSalePrintDelivery()"
                        :disabled="SaleSaveStatus"
                        variant="primary"
                        ><i class="fa fa-check"></i> Generate Delivery Note
                        <b-spinner v-if="SaleSaveStatus" small></b-spinner>
                      </b-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Tin</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Tin "
            class="form-control"
            @keyup.enter="submitTin()"
            v-model="customerdata.tindata.tin"
          />
        </div>
        <div class="text-warning" v-if="!tinError && data.efris_status == 0">
          <em>Enter Tin and Press Enter Key to Validate</em>
        </div>
        <div class="text-danger" v-if="tinError">
          <em>{{ tinError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Name "
            class="form-control"
            @input="resetErrors()"
            v-model="customerdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Contact <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Phone Number"
            class="form-control"
            v-model="customerdata.contact"
            @input="resetErrors()"
          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group">
        <label>Select Outlet <span class="text-danger">*</span></label>
        <model-list-select
          :list="RetailOutlets ? RetailOutlets : []"
          v-model="customerdata.category_id"
          option-value="id"
          option-text="name"
          placeholder="Select Outlet"
        >
        </model-list-select>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addCustomer('add-customer-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Customer modal starts -->
    <b-modal id="add-staff-modal" hide-footer @hidden="resetStaff">
      <template #modal-title> Add Staff </template>

      <div class="form-group mb-3">
        <label>Staff Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Name "
            class="form-control"
            @input="resetErrors()"
            v-model="staffdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Staff Contact</label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Phone Number"
            class="form-control"
            v-model="staffdata.contact"
            @input="resetErrors()"
          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-staff-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="StaffSave" type="button" class="btn btn-primary">
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            disabled
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addStaff('add-staff-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal mark as expired starts -->
    <b-modal id="hold-modal" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">Sale Holding</h4></template
      >
      <label>Identification <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="hold.identification"
          placeholder="Identify Order"
          @input="resetErrors()"
        />
      </div>
      <div class="text-danger" v-if="identificationError">
        <em>{{ identificationError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('hold-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="holdSale('hold-modal')"
        >
          <i class="fa fa-ban"></i> Confirm Hold
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal edit item starts -->
    <b-modal
      id="edit-item-modal"
      class="text-primary"
      hide-footer
      @hidden="resetEdit()"
    >
      <template #modal-title> Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
          @input="resetErrors(), validateQty1()"
        />
        <div class="text-danger" v-if="quantity1Error">
          <em>{{ quantity1Error }}</em>
        </div>
      </div>
      <div
        class="form-group mb-3"
        v-if="MyUserPerm && MyUserPerm.edit_selling_price == 1"
      >
        <label>Unit Price</label>
        <input
          type="text"
          class="form-control"
          step="any"
          v-model="editdata.unit_price"
          @input="editBuyingCommas()"
        />
        <div class="text-danger" v-if="unit_priceError">
          <em>{{ unit_priceError }}</em>
        </div>
      </div>
      <div class="col-sm-5" v-if="GeneralSettings.sale_discount == 1">
        <div class="form-group mb-3">
          <label style="font-size: 18px"
            >Discount Received
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="openDiscountModal('add-item', data.product)"
              style="padding: 2px 8px; font-size: 12px; margin-left: 5px"
            >
              %
            </b-button>
          </label>
          <input
            type="text"
            style="font-size: 15px"
            class="form-control"
            v-model="data.discount"
            @keyup.enter="addToCart()"
            @input="discountCommas(), showBalance()"
            min="0"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal
      id="delete-item-modal"
      class="text-danger"
      hide-footer
      @hidden="resetDeleteItem"
    >
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="unhold-item-modal" class="text-danger" hide-footer>
      <template #modal-title>UnHold Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Are you sure you want to UnHold this Order?.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('unhold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="UnHoldOrder('unhold-item-modal')"
        >
          <i class="fa fa-check"></i> UnHold
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="UnHolding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-hold-item-modal" class="text-danger" hide-footer>
      <template #modal-title> Delete Held Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to this Order? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-hold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteHeldItem('delete-hold-item-modal')"
        >
          <i class="fa fa-trash"></i> Delete
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal for adding items -->
    <b-modal id="add-item-modal" class="text-primary" hide-footer>
      <template #modal-title> Add Item to this Order</template>
      <div class="form-group mb-3">
        <label>Product <span class="text-danger">*</span></label>
        <model-list-select
          :list="Products ? Products : []"
          v-model="add.product"
          option-value="id"
          option-text="name2"
          placeholder="Select Product"
          @input="resetErrors(), assignArr2()"
        >
        </model-list-select>
        <div class="text-danger" v-if="itemError">
          <em>{{ itemError }}</em>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Quantity</label>
            <input
              type="number"
              class="form-control"
              step="any"
              v-model="add.quantity"
              @keyup.enter="addToCart1()"
              @input="resetErrors(), validateQty2()"
            />
          </div>
          <div class="text-danger" v-if="qtyError">
            <em>{{ qtyError }}</em>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Unit Measure <span class="text-danger">*</span></label>
            <model-list-select
              :list="unitsArr ? unitsArr : []"
              v-model="add.unit"
              option-value="id"
              option-text="unitname"
              placeholder="Unit"
              @input="resetErrors()"
              @keyup.enter="addToCart1()"
            >
            </model-list-select>
            <div class="text-danger" v-if="unitError">
              <em>{{ unitError }}</em>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addToCart1('add-item-modal')"
        >
          <i class="fa fa-plus"></i> Add Item
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Adding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!--  end row -->

    <!-- Discount Percent Modal -->
    <b-modal
      id="discount-percent-modal"
      hide-footer
      @hidden="resetDiscountModal"
    >
      <template #modal-title>
        Calculate % Discount
        <small class="text-muted" v-if="discountModalContext.itemName">
          ({{ discountModalContext.itemName }})
        </small>
      </template>

      <div class="form-group mb-3">
        <label>Discount Percentage (%)</label>
        <div class="input-group">
          <input
            v-model.number="discountPercentValue"
            type="number"
            min="0"
            max="100"
            step="0.01"
            class="form-control"
            placeholder="e.g. 10"
            @input="calculateDiscount"
          />
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('discount-percent-modal')"
        >
          <i class="fa fa-times"></i> Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="applyPercentDiscount"
        >
          <i class="fa fa-check"></i> Apply Discount
        </button>
      </div>
    </b-modal>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 80px;
  z-index: 1000;
}

.fixed-header-spacer {
  margin-top: 90px;
}
</style>
